<template>
  <div :class="['wizard-largeoption-button', (isSelected) ? buttonBackgroundClass : '']" @click.prevent="onClicked">
    <div class="wizard-largeoption-icon">
      <i :class="['fa', icon, 'fa-fw']"></i>
    </div>
    <div class="wizard-largeoption-content">
      <div class="wizard-largeoption-title text-uppercase">{{title}}</div>
      <div class="mt-4">
        <i class="far fa-square fa-3x" v-if="!isSelected"></i>
        <i class="far fa-check-square fa-3x" v-if="isSelected"></i>
      </div>
    </div>
  </div>
</template>

<style scoped>
.wizard-largeoption-button {
  position: relative;
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  color: #ffffff;
  overflow: hidden;
  min-height: 125px;
  max-height: 125px;
  background-color: #a0a0a0;
  cursor: pointer;
}
.button-bg1 { background-color: #348fe2; }
.button-bg2 { background-color: #7F43D5; }
.button-bg3 { background-color: #269e58; }
.button-bg4 { background-color: #f0932b; }
.button-bg5 { background-color: #c23616; }
.button-bg6 { background-color: #8c7ae6; }
.button-bg7 { background-color: #487eb0; }
.button-bg8 { background-color: #B33771; }
.button-bg9 { background-color: #20bac5; }
.button-bg10 { background-color: #34495e; }

.wizard-largeoption-icon {
  font-size: 128px;
  top: 15px;
  right: 0;
  color: #fff;
  width: 128px;
  height: 50px;
  line-height: 50px;
  text-shadow: 3px 7px rgba(0,0,0,.25);
  opacity: .15;
  text-align: center;
  position: absolute;
  margin-left: 15px;
}
.wizard-largeoption-content {
  position: relative;
}
.wizard-largeoption-title {
  font-size: 16px;
  margin: 0px 0px 2px;
}
</style>

<script>
export default {
  name: 'WizardLargeOptionButton',
  model: {
    event: 'change'
  },
  props: {
    title: String,
    icon: String,
    setting: String,
    value: String,
    buttonBackgroundClass: {
      type: String,
      default: 'button-bg1'
    }
  },
  computed: {
    isSelected() {
      return this.value == this.setting
    },
    isNoneSelected() {
      return this.value == null || this.value == ''
    }
  },
  methods: {
    onClicked() {
      this.$emit('change', this.setting)
    }
  }
}
</script>